var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcMetamask = function SvgIcMetamask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_metamask_svg__a)",
    strokeWidth: 0.297,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.022 2 22.397 13.562l2.905-6.814L38.022 2Z",
    fill: "#E17726",
    stroke: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.979 2 15.486 11.67L14.7 6.748 1.979 2ZM32.394 28.808l-4.158 6.352 8.903 2.451 2.55-8.664-7.295-.139ZM.324 28.947l2.535 8.664 8.887-2.451-4.142-6.351-7.28.138Z",
    fill: "#E27625",
    stroke: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.268 18.079-2.473 3.73 8.81.401-.294-9.48-6.043 5.349ZM28.733 18.08l-6.136-5.458-.2 9.589 8.81-.401-2.474-3.73ZM11.746 35.16l5.332-2.574-4.59-3.577-.742 6.15ZM22.922 32.586l5.317 2.574-.727-6.151-4.59 3.577Z",
    fill: "#E27625",
    stroke: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.239 35.16-5.317-2.574.433 3.453-.047 1.464 4.93-2.343ZM11.746 35.16l4.946 2.343-.03-1.464.416-3.453-5.332 2.574Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.786 26.727-4.42-1.294 3.121-1.434 1.299 2.728ZM23.215 26.727 24.513 24l3.138 1.434-4.436 1.294Z",
    fill: "#233447",
    stroke: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.746 35.16.772-6.351-4.914.138 4.142 6.213ZM27.48 28.808l.758 6.352 4.157-6.213-4.915-.139ZM31.206 21.81l-8.81.4.82 4.517L24.514 24l3.137 1.433 3.555-3.622ZM12.365 25.432 15.487 24l1.299 2.728.819-4.517-8.81-.4 3.57 3.622Z",
    fill: "#CC6228",
    stroke: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.795 21.81 3.694 7.199-.124-3.577-3.57-3.622ZM27.65 25.432l-.138 3.577 3.694-7.2-3.555 3.623ZM17.604 22.21l-.819 4.517 1.036 5.334.232-7.03-.449-2.82ZM22.396 22.21l-.433 2.806.216 7.045 1.036-5.334-.82-4.517Z",
    fill: "#E27525",
    stroke: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.215 26.727-1.035 5.334.742.525 4.59-3.577.14-3.576-4.437 1.294ZM12.365 25.433l.124 3.576 4.59 3.577.742-.525-1.035-5.334-4.42-1.294Z",
    fill: "#F5841F",
    stroke: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.307 37.503.046-1.464-.401-.34h-5.905l-.386.34.031 1.464-4.946-2.343 1.731 1.418 3.509 2.42h6.012l3.524-2.42 1.715-1.418-4.93 2.343Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.922 32.586-.742-.525H17.82l-.742.525-.417 3.453.387-.34h5.904l.402.34-.433-3.453Z",
    fill: "#161616",
    stroke: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.687 14.317 40 7.935 38.022 2l-15.1 11.177 5.811 4.902 8.207 2.39 1.809-2.113-.789-.57 1.252-1.14-.958-.74 1.252-.957-.82-.632ZM0 7.935l1.33 6.382-.85.633 1.267.955-.959.74 1.252 1.141-.788.57 1.808 2.112 8.207-2.389 5.812-4.902L1.979 2 0 7.935Z",
    fill: "#763E1A",
    stroke: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.94 20.468-8.207-2.389 2.473 3.73-3.694 7.2 4.884-.062h7.295l-2.751-8.479ZM11.267 18.079l-8.207 2.39-2.736 8.478h7.28l4.884.062-3.694-7.2 2.473-3.73ZM22.396 22.21l.526-9.033 2.38-6.429H14.699l2.38 6.429.526 9.034.2 2.836.016 7.014h4.359l.015-7.014.201-2.837Z",
    fill: "#F5841F",
    stroke: "#F5841F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_metamask_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgIcMetamask;